<button
  id="{{ id }}"
  type="button"
  class="btn btn-{{ type }} {{ customClass }}"
  (click)="onClick()"
  (keydown)="onKeyDown($event)"
  [disabled]="isDisabled"
  [attr.aria-label]="ariaLabel"
  [attr.aria-controls]="ariaControls"
  [attr.aria-expanded]="ariaExpanded"
  [attr.aria-pressed]="ariaPressed"
  [attr.aria-describedby]="ariaDescribedby"
  [ngStyle]="{
    background: backgroundColor,
    color: fontColor,
    borderColor: backgroundColor
  }"
>
  <ng-content />
</button>
